export default __webpack_public_path__ + "public/live.3ef47ea295d22a910b7927074816eb61.csv";